export default "__VITE_ASSET__C0BFL_gG__"